import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getProduct = (
    backend: string,
    token: string,
    id: number,
) => {
    return fetch(
        `${getApiUrl(backend)}products/${id}`,
        {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
};

export default getProduct